import React from "react";
import "./GoForLoginModal.css";

const GoForLoginModal = ({ isOpen, onClose, onSuccess }) => {
    if (!isOpen) return null;
    
    const handleClose = () => {
        onClose();
    };

    const handleLogin = () => {
        onSuccess();
    };

    return (
        <>
            {/* Backdrop */}
            <div
                className="login-modal-backdrop fade show"
                onClick={handleClose}
            />

            {/* Modal */}
            <div
                className="modal fade show login-prompt-modal"
                tabIndex="-1"
                aria-labelledby="loginPromptModalLabel"
                aria-modal="true"
                role="dialog"
                style={{ display: 'block', zIndex: 1050 }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content login-modal-content">
                        <button 
                            type="button" 
                            className="btn-close login-modal-close" 
                            onClick={handleClose} 
                            aria-label="Close"
                        />
                        
                        <div className="modal-body text-center py-5 px-4">
                            {/* Icon with animated gradient background */}
                            <div className="login-icon-wrapper mb-4">
                                <div className="login-icon-bg">
                                    <i className="bi bi-shield-lock-fill login-icon"></i>
                                </div>
                            </div>

                            {/* Title */}
                            <h3 className="login-modal-title mb-3">
                                Authentication Required
                            </h3>

                            {/* Message */}
                            <p className="login-modal-message mb-4">
                                Please log in to your account to continue. 
                                You need to be authenticated to access this feature and explore the full NFT marketplace experience.
                            </p>

                            {/* Benefits list */}
                            {/* <div className="login-benefits mb-4">
                                <div className="benefit-item">
                                    <i className="bi bi-check-circle-fill"></i>
                                    <span>Buy and sell NFTs</span>
                                </div>
                                <div className="benefit-item">
                                    <i className="bi bi-check-circle-fill"></i>
                                    <span>View my profile</span>
                                </div>
                            </div> */}

                            {/* Action Buttons */}
                            <div className="login-modal-actions">
                                <button
                                    type="button"
                                    className="btn BtnBlack login-btn-primary"
                                    onClick={handleLogin}
                                >
                                    <i className="bi bi-box-arrow-in-right me-2"></i>
                                    Log In Now
                                </button>
                                <button
                                    type="button"
                                    className="btn login-btn-secondary"
                                    onClick={handleClose}
                                >
                                    Maybe Later
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GoForLoginModal;



